import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=4d5068b4&scoped=true&lang=pug&"
import script from "./Menu.vue?vue&type=script&lang=js&"
export * from "./Menu.vue?vue&type=script&lang=js&"
import style0 from "./Menu.styl?vue&type=style&index=0&id=4d5068b4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5068b4",
  null
  
)

export default component.exports